import { AlertCircle, AlertTriangle, Check, Info } from '@tamagui/lucide-icons';
import { useActiveColorScheme } from '@unistocks/shared/hooks/use-active-color-scheme';
import { getVariableValue, isWeb } from 'tamagui';
import { Toaster, ToasterProps } from './toast';

const icons: ToasterProps['icons'] = {
  success: <Check color={'$success'} />,
  error: <AlertCircle color={'$danger'} />,
  warning: <AlertTriangle color={'$warning'} />,
  info: <Info color={'$unistocks'} />
};

export function ToastContainer() {
  const { activeColorScheme } = useActiveColorScheme();
  const theme = activeColorScheme === 'unspecified' ? 'system' : activeColorScheme;
  const gap = getVariableValue('$3', 'space');

  /* useEffect(() => {
    const interval = setInterval(() => {
      toast.info('Welcome to Unistocks!', { description: 'This is an info toast.' });
      toast.error('Unistocks error!', { description: 'This is an error toast.' });
      toast.success('Unistocks successfully saved!', { description: 'This is a success toast.' });
    }, 5000);

    return () => clearInterval(interval);
  }, []); */

  return (
    <Toaster
      expand
      position="top-center"
      closeButton={isWeb}
      visibleToasts={5}
      icons={icons}
      theme={theme}
      gap={gap}
      duration={5000}
      /* @ts-expect-error - Only on native */
      swipeToDismissDirection={'left'}
      enableStacking
    />
  );
}
